import type { SettingsMenuItem, SettingsSubMenuItem } from "@/types/settings";

export function visibleSettingsSubmenu(
  sections: SettingsSubMenuItem[] | undefined
): SettingsSubMenuItem[] {
  return (sections ?? []).filter((s) => !s.hidden);
}

export function shouldExpandSettingsSubmenu(category: SettingsMenuItem): boolean {
  if (category.expandSections) {
    return visibleSettingsSubmenu(category.sections).length > 0;
  }

  return visibleSettingsSubmenu(category.sections).length > 1;
}

export const createAdminSettingsCategories = (): SettingsMenuItem[] => [
  {
    key: "general",
    label: "generic.fields.sections.general",
    icon: "mdi-cog-outline",
    sections: [
      {
        key: "software",
        label: "features.adminSettings.menu.general.sections.software",
        icon: "mdi-information-outline",
      },
      {
        key: "development",
        label: "features.adminSettings.menu.general.sections.development",
        icon: "mdi-account-hard-hat-outline",
      },
    ],
  },
  {
    key: "users",
    label: "features.adminSettings.menu.users.title",
    icon: "mdi-account-group-outline",
    sections: [
      {
        key: "users",
        label: "features.adminSettings.menu.users.title",
        icon: "mdi-account-outline",
      },
      {
        key: "group-permissions",
        label: "features.adminSettings.groupPermissions.title",
        icon: "mdi-shield-account-outline",
      },
      {
        key: "job-permissions",
        label: "models.settings.jobPermissions.title",
        icon: "mdi-briefcase-outline",
      },
      {
        key: "invite-roles",
        label: "features.adminSettings.menu.users.sections.inviteRoles",
        icon: "mdi-badge-account-outline",
      },
    ],
  },
  {
    key: "flowsConfigurator",
    label: "features.adminSettings.menu.flowsConfigurator.title",
    icon: "mdi-sitemap-outline",
    sections: [
      {
        key: "list",
        label: "features.adminSettings.menu.flowsConfigurator.sections.list",
        icon: "mdi-server-outline",
      },
    ],
  },
  {
    key: "qrConfigurator",
    label: "features.adminSettings.menu.qrConfigurator.title",
    icon: "mdi-qrcode-edit",
    sections: [
      {
        key: "list",
        label: "features.adminSettings.menu.qrConfigurator.sections.list",
        icon: "mdi-server-outline",
      },
    ],
  },
  {
    key: "termsAndConditions",
    label: "features.adminSettings.menu.termsAndConditions.title",
    icon: "mdi-file-document-edit-outline",
    sections: [
      {
        key: "list",
        label: "features.adminSettings.menu.termsAndConditions.sections.list",
        icon: "mdi-format-list-bulleted",
      },
      {
        key: "version-edit",
        label: "features.adminSettings.menu.termsAndConditions.sections.list",
        icon: "",
        hidden: true,
      },
      {
        key: "version-history",
        label: "features.adminSettings.menu.termsAndConditions.sections.list",
        icon: "",
        hidden: true,
      },
    ],
  },
  {
    key: "medical",
    label: "features.adminSettings.menu.medical.title",
    icon: "mdi-clipboard-text-outline",
    expandSections: true,
    sections: [
      {
        key: "insurances",
        label: "models.settings.permissions.categories.names.insurancecompany",
        icon: "mdi-shield-plus-outline",
      },
    ],
  },
  {
    key: "products",
    label: "features.adminSettings.menu.products.title",
    icon: "mdi-package-variant-closed",
    sections: [
      {
        key: "list",
        label: "features.adminSettings.menu.products.sections.list",
        icon: "mdi-package-variant-closed",
      },
    ],
  },
  {
    key: "backoffice",
    label: "generic.navbar.paths.backoffice",
    icon: "mdi-briefcase-outline",
    sections: [
      {
        key: "customPlans",
        label: "features.backoffice.customPlans.title",
        icon: "mdi-domain",
      },
      {
        key: "subscriptionRequests",
        label: "features.backoffice.subscriptionRequests.title",
        icon: "mdi-swap-horizontal",
      },
    ],
  },
  {
    key: "data",
    label: "features.adminSettings.menu.data.title",
    icon: "mdi-database-outline",
    disabled: true,
  },
  {
    key: "thirdparty",
    label: "features.adminSettings.menu.thirdparty.title",
    icon: "mdi-link-variant",
    sections: [
      {
        key: "platforms",
        label: "models.settings.permissions.categories.names.platform",
        icon: "mdi-link-variant",
      },
    ],
  },
];
